import { render, staticRenderFns } from "./BikeProduct.vue?vue&type=template&id=1a49d140&"
import script from "./BikeProduct.vue?vue&type=script&lang=js&"
export * from "./BikeProduct.vue?vue&type=script&lang=js&"
import style0 from "./BikeProduct.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports